import React from 'react';
import { Shield, Cpu } from 'lucide-react';
import { EnumAiAutomationLevel, EnumArmProfile } from '@/lib/api/types.gen';
import { cn } from '@/lib/utils';

export function ArmBadge({ value }: { value?: EnumArmProfile }) {
  const label = value ?? EnumArmProfile.Auto;
  const styles =
    label === EnumArmProfile.Armed
      ? 'bg-green-200/20 text-white'
      : label === EnumArmProfile.Disarmed
        ? 'bg-red-300/20 text-white/70'
        : label === EnumArmProfile.TestMode
          ? 'bg-yellow-300/20 text-white/70'
          : 'bg-green-600/20 text-white/70';
  const title =
    label === EnumArmProfile.Armed
      ? 'Site is always armed'
      : label === EnumArmProfile.Disarmed
        ? 'Site is never armed'
        : label === EnumArmProfile.TestMode
          ? 'Testing mode'
          : 'Automatic arming based on rules';

  return (
    <span
      title={title}
      className={cn('inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-semibold', styles)}
    >
      <Shield className="h-3 w-3" /> {label}
    </span>
  );
}

export function AiBadge({ value }: { value?: EnumAiAutomationLevel }) {
  const level = value ?? EnumAiAutomationLevel.None;
  const styles =
    level === EnumAiAutomationLevel.None
      ? 'bg-red-600/20 text-white/70'
      : level === EnumAiAutomationLevel.Assistant
        ? 'bg-purple-500/20 text-white'
        : 'bg-green-500/20 text-white';
  const title =
    level === EnumAiAutomationLevel.None
      ? 'Manual investigations only'
      : level === EnumAiAutomationLevel.Assistant
        ? 'Assisted AI automation'
        : 'Full AI automation';

  return (
    <span
      title={title}
      className={cn('inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-semibold', styles)}
    >
      <Cpu className="h-3 w-3" /> {level}
    </span>
  );
}
